import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridLayout, HeadCellsCollection } from 'shared/ui/grid-layout';
import { IPagingData, WccDto } from '@sr/dto';
import { formatDate } from 'utils/date-format-helpers';
import PriceSpan from 'shared/ui/price-span';
import { LinkToWcc } from 'shared/ui/links/link-to-wcc';
import { LinkToLegalEntity } from 'shared/ui/links/link-to-legal-entity';
import { LinkToCompany } from 'shared/ui/links/link-to-company';
import { LinkToInvoice } from 'entities/client-invoices-list/ui/link-to-invoice';
import { formatPerson } from 'utils/person-format-helpers';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { ListTotalsCard } from 'shared/ui/totals-card';

const WCC_LIST_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 300, 1000];

type Props = {
  collection: IRemotePagedCollection<WccDto>;
  paging: IPagingData;
  onChangePaging: (paging: IPagingData) => void;
  onDelete: (wcc: WccDto) => void;
  type?: 'client' | 'supplier';
};

export const WccList = ({ collection, paging, onChangePaging, onDelete, type = 'client' }: Props) => {
  const columns: HeadCellsCollection = [
    'Номер акта',
    'Счет',
    (type === 'client' ? 'Наше юрлицо' : 'Поставщик'),
    (type === 'client' ? 'Клиент' : 'Наше юрлицо'),
    'Дата',
    'Менеджер',
    { label: 'Сумма', align: 'right' },
    ''
  ];
  const metaWccAmountTotal = collection.collection.meta?.find((x) => x['amountTotal'] !== undefined)?.['amountTotal'];
  const totalSum = metaWccAmountTotal ?? collection.collection.items.reduce((acc, wcc) => acc + wcc.amount, 0);
  return (
    <Box>
      <GridLayout
        tableOptions={{ component: 'div' }}
        columns={columns}
        items={collection.collection.items}
        isLoading={collection.isLoading}
        pagingData={paging}
        onChangePaging={onChangePaging}
        totalItemsCount={collection.collection.totalItemsCount}
        error={collection.error}
        itemRender={(wcc) => <Row key={wcc.id} wcc={wcc} onDeleteClick={() => onDelete(wcc)} />}
        renderCustomHeader={() => <ListTotalsCard meta={[{ title: 'Сумма', value: metaWccAmountTotal }]} />}
        footer={() => <WccFooter totalSum={totalSum} />}
        itemsPerPageOptions={WCC_LIST_ITEMS_PER_PAGE_OPTIONS}
        noItemsText="Список актов пуст"
      />
    </Box>
  );
};


const WccFooter = ({ totalSum }: { totalSum: number }) => {
  return (
    <TableRow>
      <TableCell colSpan={6} align="right">
        <Typography>Итого:</Typography>
      </TableCell>
      <TableCell align="right">
        <PriceSpan price={totalSum} />
      </TableCell>
      <TableCell ></TableCell>
    </TableRow>
  );
};


type RowProps = {
  wcc: WccDto,
  onDeleteClick: () => void;
};

const Row = ({ wcc, onDeleteClick }: RowProps) => {
  return (
    <TableRow>
      <TableCell >
        <LinkToWcc wcc={wcc} />
      </TableCell>
      <TableCell>
        <LinkToInvoice invoice={wcc.invoice} />
      </TableCell>
      <TableCell>
        <LinkToLegalEntity legalEntity={wcc.invoice.seller} />
      </TableCell>
      <TableCell>
        <Box>
          <LinkToCompany company={wcc.invoice.buyerCompany} />
        </Box>
        <Box>
          <LinkToLegalEntity legalEntity={wcc.invoice.buyer} />
        </Box>
      </TableCell>
      <TableCell>
        {formatDate(wcc.date)}
      </TableCell>
      <TableCell>
        {wcc.invoice.manager ? formatPerson(wcc.invoice.manager) : '-'}
      </TableCell>
      <TableCell align="right">
        <PriceSpan size='small' price={wcc.amount} />
      </TableCell>
      <TableCell align="right" width={100}>
        <IconButton edge="end" onClick={onDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow >
  );
};




